import React, { FC } from 'react';
import { Controller, Control, UseFormWatch } from 'react-hook-form';
import { FormControlLabel, Checkbox, Box, FormLabel, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReportConfigDto } from '@thingslog/repositories';

interface LicenseReportSettingsFormProps {
  control: Control<ReportConfigDto>;
  watch: UseFormWatch<ReportConfigDto>;
}

const LicenseReportSettingsForm: FC<LicenseReportSettingsFormProps> = ({
  control,
  watch,
}: LicenseReportSettingsFormProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Box className="border border-gray-300 rounded p-4">
      <FormLabel component="legend" className="mb-2">
        {t('report_config_form_license_settings')}
      </FormLabel>
      <FormGroup>
        <Controller
          name="reportSettings.isActive"
          control={control}
          defaultValue={false}
          render={({ field }: { field: any }): React.ReactElement => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={field.value || false}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                    field.onChange(e.target.checked)
                  }
                />
              }
              label={t('report_config_form_license_is_active')}
            />
          )}
        />
        <Controller
          name="reportSettings.isValid"
          control={control}
          defaultValue={false}
          render={({ field }: { field: any }): React.ReactElement => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={field.value || false}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                    field.onChange(e.target.checked)
                  }
                />
              }
              label={t('report_config_form_license_is_valid')}
            />
          )}
        />
      </FormGroup>
    </Box>
  );
};

export default LicenseReportSettingsForm;
